const ssn = {
    ssn : {
        value: "",
        dbqName: "F[0].Page_1[0].SSN[0]"
     },
     docName: {
         value: "",
         dbqName: "F[0].#subform[3].Page_3[1].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "F[0].#subform[3].Page_3[1].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "F[0].#subform[3].Page_3[1].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "F[0].#subform[3].Page_3[1].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "F[0].#subform[3].Page_3[1].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "F[0].#subform[3].Page_3[1].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "F[0].#subform[3].Page_3[1].TextField8[5]"
    },
    diagnosisDate : [
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Migraine[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis[5]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Tension[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis[4]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Cluster[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Other[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis[1]",
        },
        {
            type: "text",
            dbqName: "F[0].Page_2[0].Diagnosis1[1]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis[2]",
        },
        {
            type: "text",
            dbqName: "F[0].Page_2[0].Diagnosis1[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis[3]",
        }      
    ]
}

export default ssn ;